module.exports = __webpack_public_path__ + "img/feature-tile-icon-04.944b2810.svg";